(function() {
  'use strict';
  angular.module('eclipseApp.core').controller('availabilityModalCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    'serviceabilityService',
    '$modalInstance',
    'cartManager',
    'samKeyService',
    'data',
    '$window',
    'commonService',
    '$translate',
    '$q',
    '$localStorage',
    'buySession',
    'provinceService',
    'janrainService',
    'buyService',
    '$timeout',
    'uteLocale',
    'util',
    'dtmService',
    'dtmServiceConstants',
    'brt',
    '$modal',
    'vcRecaptchaService',
    'env',
    'brtSwitchCMS',
    function(
      $scope,
      $rootScope,
      $state,
      serviceabilityService,
      $modalInstance,
      cartManager,
      samKeyService,
      data,
      $window,
      commonService,
      $translate,
      $q,
      $localStorage,
      buySession,
      provinceService,
      janrainService,
      buyService,
      $timeout,
      uteLocale,
      util,
      dtmService,
      dtmServiceConstants,
      brt,
      $modal,
      vcRecaptchaService,
      env,
      brtSwitchCMS
    ) {
      var _self = {};
      _self.samKey;
      _self.queriedAddress = {};
      _self.serviceableAddress;
      $scope.multiUnitDisplay = 0;
      $scope.flowService = data.service;

      console.log('vcRecaptchaService', vcRecaptchaService);

      if (data.service === 'iptv') {
        _self.userEligibleToCheckout = buyService.isEligibleToTvCheckout() || null;
      } else {
        _self.userEligibleToCheckout = buyService.isEligibleToCheckout() || null;
      }

      var getTranslations = function() {
        //Translation Keys for TV & Internet
        if (data.service === 'iptv') {
          var promises = [
            $translate('global.label.checkTVAvailabilityPromptLoggedIn'),
            $translate('global.label.notServiceableTV'),
            $translate('retail.label.notServiceableTV'),
            $translate('good-news-eclipse-tv-is-available-at'),
            $translate('agent-customer-good-news-eclipse-tv-is-available-at'),
            $translate('global.label.tvPackages')
          ];
        } else {
          var promises = [
            $translate('global.label.checkAvailabilityPromptLoggedIn'),
            $translate('global.label.notServiceable'),
            $translate('retail.label.notServiceable'),
            $translate('good-news-fido-internet-is-available-at'),
            $translate('agent-customer-good-news-fido-internet-is-available-at'),
            $translate('global.label.internetPackages')
          ];
        }

        promises[0].then(function(text) {
          $scope.checkAvailabilityPromptLoggedIn = text;
        });

        promises[1].then(function(text) {
          $scope.notServiceable = text;
        });

        promises[2].then(function(text) {
          $scope.retailNotServiceable = text;
        });

        promises[3].then(function(text) {
          $scope.goodNewsServiceIsAvailableAt = text;
        });

        promises[4].then(function(text) {
          $scope.goodNewsAgentServiceIsAvailableAt = text;
        });

        promises[5].then(function(text) {
          $scope.servicePackages = text;
        });
      };

      $translate('global.message.notServiceable').then(function(text) {
        $scope.notServiceableMessage = text;
      });
      $translate('retail.message.callSupport').then(function(text) {
        $scope.retailNotServiceableMessage = text;
      });
      $translate('retail.label.notServiceable').then(function(text) {
        $scope.retailNotServicable = text;
      });

      getTranslations();

      console.log('--availabilityModalCtrl (data, _self)', data, _self);

      // initialize the loader
      $scope.processing = {
        loading: true
      };

      // no serviceability lookup happening right now
      $scope.checkingServiceability = false;

      // event catcher, in case
      $scope.$on('addressCompleteReady', function(e) {
        $scope.processing.loading = false;
      });

      var sessionServiceableAddress = {},
        ssServiceableAddressResponse;

      // set default scope vars
      _self.queriedAddress = {};
      $scope.serviceable = {};
      $scope.serviceability = {};
      $scope.newProvince = '';
      $scope.address = null;

      $scope.serviceability.invalidAction = null;
      $scope.serviceability.processing = null; // TBD to be used as one processing reference to view

      $scope.serviceability.token = null;

      $scope.cartNotEmpty = function() {
        if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) return false;
        return cartManager.getQuantity() > 0;
      };

      // view states tags
      var RESEARCH_MY_ADDRESS = 'researchMyAddress',
        ADDRESS_NOT_FOUND = 'addressNotFound',
        SERVICEABLE = 'serviceable',
        NOT_SERVICEABLE = 'notServiceable',
        FRAUD = 'fraud',
        OTHER_PROVINCE = 'otherProvince',
        SERVER_ERROR = 'serverError',
        OFFER_NOT_AVAILABLE = 'offerNotAvailable',
        ERROR = 'error',
        MULTIPLE_UNITS = 'multipleUnits',
        INVALID_AUID = 'invalidAUID',
        UNWIRED = 'Unwired'; //CH-4586

      // the default state of the modal
      var defaultState = {
        signIn: true,
        checkAddress: true,
        action: '',
        flag: '',
        eligible: _self.userEligibleToCheckout,
        user: {
          context: $rootScope.ruiMethods.user.is.agent()
            ? $rootScope.ruiMethods.agent.has.customerContext()
            : $rootScope.ruiMethods.user.is.loggedIn(),
          isLoggedIn: $rootScope.ruiMethods.user.is.loggedIn(),
          isAgent: $rootScope.ruiMethods.user.is.agent(),
          isAuth: $rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent(),
          isBRTPeriod: brt.isBRTPeriod(),
          isBRTSession: brt.isBRTSession(),
          isByPassRecaptcha: $rootScope.isByPassed ? $rootScope.isByPassed : false
        }
      };

      var setState = function(state, param) {
        var toState,
          states = {
            default: function() {
              toState = defaultState;
              return toState;
            },
            addressNotFound: function() {
              toState = _.defaults(
                {
                  action: RESEARCH_MY_ADDRESS,
                  flag: ADDRESS_NOT_FOUND,
                  signIn: false,
                  checkAddress: true
                },
                defaultState
              );
              $scope.serviceable.address = '';

              for (var _key in toState) {
                if (_key === 'checkAddress') {
                  toState[_key] = _.has(param, 'checkAddress') ? param.checkAddress : true;
                  break;
                }
              }

              return toState;
            },
            serviceable: function() {
              toState = _.defaults(
                {
                  action: SERVICEABLE,
                  checkAddress: data.service === 'btsPromotion' ? true : false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            fraud: function() {
              toState = _.defaults(
                {
                  signIn: false,
                  checkAddress: false,
                  action: FRAUD
                },
                defaultState
              );
              return toState;
            },
            notServiceable: function() {
              toState = _.defaults(
                {
                  flag: NOT_SERVICEABLE,
                  signIn: false
                },
                defaultState
              );
              $scope.serviceable.address = '';
              return toState;
            },
            otherProvince: function() {
              toState = _.defaults(
                {
                  action: OTHER_PROVINCE,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            serverError: function() {
              toState = _.defaults(
                {
                  action: SERVER_ERROR,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            offerNotAvailable: function() {
              toState = _.defaults(
                {
                  action: OFFER_NOT_AVAILABLE,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            error: function() {
              toState = _.defaults(
                {
                  action: ERROR,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            multipleUnits: function() {
              toState = _.defaults(
                {
                  action: MULTIPLE_UNITS,
                  addressInfoList: _.has(param, 'addressInfoList') ? param.addressInfoList : [],
                  signIn: false,
                  checkAddress: false
                },
                defaultState
              );
              /* reset multi unit form here */
              if (_.has(param, 'addressInfoList') && param.addressInfoList.length > 5) {
                /* dropdown here */
                $scope.selectedMultiAddress = param.addressInfoList[0];
                $scope.selectedMultiAddress.addressSelected = true;
                $scope.selectedMultiAddress.addressPrestine = false;
              } else {
                /* radio here */
                $scope.selectedMultiAddress = {};
              }

              $scope.multiUnitDisplay = $scope.multiUnitDisplay + 1;

              return toState;
            },
            invalidAUID: function() {
              toState = _.defaults(
                {
                  action: INVALID_AUID,
                  flag: INVALID_AUID,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            },
            Unwired: function() {
              //CH-4586
              toState = _.defaults(
                {
                  action: UNWIRED,
                  flag: UNWIRED,
                  checkAddress: false,
                  signIn: false
                },
                defaultState
              );
              return toState;
            }
          };

        // set scope values that will set what msg to show in the modal
        $scope.serviceability = states[state]();
        console.info('setstate');
      };

      // set the default view of the modal on open
      setState('default');

      // debug
      $scope.setState = function(state) {
        console.log('++DEBUG SETTING STATE TO: ', state);
        $scope.checkingServiceability = false;
        setState(state);
      };
      $scope.toggleProcessing = function() {
        $scope.checkingServiceability = !$scope.checkingServiceability;
      };
      // end debug

      $scope.cantFindMyAddress = function() {
        setState('addressNotFound', { checkAddress: false });
      };

      $scope.recaptcha = {
        sitekey: env.recaptcha ? env.recaptcha : '',
        initial: null,
        multiUnit: null
      };

      $scope.hideInitial = false;

      $scope.setWidgetID = function(widgetId, name) {
        $scope.recaptcha[name] = {
          widgetId: widgetId,
          token: null
        };
        vcRecaptchaService.useLang(widgetId, uteLocale.language === 'en' ? 'en' : 'fr-CA');
      };

      $scope.setResponseInitial = function(response) {
        // send the `response` to your server for verification.
        $scope.recaptcha.initial.token = response;

        $scope.hideInitial = true;
        if (cartManager.getQuantity() > 0) {
          cartManager.cleanCart().then(function() {
            checkServiceability(null, $scope.recaptcha.initial.token);
          });
        } else {
          checkServiceability(null, $scope.recaptcha.initial.token);
        }
      };

      $scope.cbExpiration = function(instanceName) {
        vcRecaptchaService.reload($scope.recaptcha[instanceName].widgetId);
        vcRecaptchaService.useLang(widgetId, uteLocale.language === 'en' ? 'en' : 'fr-CA');
      };

      // $scope.lookupDisabled = true;

      // default the search enabler, unless the address has been found by CP (onclick callback)
      // $scope.$watch('serviceable.address', function(nv, ov){
      //   if (nv !== ov) {
      //     $scope.lookupDisabled = true;
      //     return;
      //   }
      // });

      // student email rule
      $scope.btsOffersFormRules = {
        emailAddress: {
          required: true,
          pattern: '(/^([w-]+(?:.[w-]+)*)@((?:[w-]+.)*w[w-]{0,66}).([a-z]{2,6}(?:.[a-z]{2})?)$/)'
        }
      };
      $scope.emailVerify = false;

      $scope.btsVerifyEmail = function(btsOffersForm) {
        if (btsOffersForm.$valid) {
          $scope.emailVerify = true;
        }
      };

      $scope.setAddressData = function(address) {
        console.log('---@setAddressData', address);

        $scope.serviceability.invalidAction = null;

        // $scope.lookupDisabled = false;
        // document.querySelector('.pca .pcaautocomplete.pcatext').style.display = undefined;
        $scope.addressNotFound = false;

        $scope.address = address;

        $scope.address.Label =
          ($scope.address.SubBuilding ? $scope.address.SubBuilding + '-' : '') +
          $scope.address.BuildingNumber +
          $scope.address.Field5 +
          ' ' +
          $scope.address.Street +
          ' ' +
          $scope.address.City +
          ' ' +
          $scope.address.Province +
          '  ' +
          $scope.address.PostalCode;

        _self.queriedAddress.city = address.City;
        _self.queriedAddress.province = address.Province;
        _self.queriedAddress.postalCode = address.PostalCode;
        _self.queriedAddress.country = address.CountryName;
        _self.queriedAddress.streetNumber = address.Field1;
        _self.queriedAddress.streetName = address.Field2;
        _self.queriedAddress.streetNumberSuffix = address.Field5;
        _self.queriedAddress.streetType = address.Field3.toUpperCase();
        _self.queriedAddress.unitNumber = address.SubBuilding;
        _self.queriedAddress.streetDirection = address.Field7.toUpperCase();
        _self.queriedAddress.cpDomesticId = address.DomesticId || '';

        if (address.POBoxNumber) {
          _self.queriedAddress.poBox = address.Line1;
        }

        $scope.researchMyAddressStatic = $scope.address.Label;
        $scope.$apply();
      };

      $scope.continue = function() {
        console.log('---OLD SAMKEY:', $rootScope.userPref.samKey);
        console.log('---NEW SAMKEY:', _self.samKey);

        // The following variable is to prevent a user to click more that once that causes this code block to execute multiple times.
        this.continueProcessing = this.continueProcessing || false;

        if (this.continueProcessing) return;

        this.continueProcessing = true;

        // NOTE: TBD set serviceable address in session for checkout use
        var sessionServiceableAddress = {
          label: $scope.address.Label,
          address: _self.queriedAddress,
          ssResp: ssServiceableAddressResponse
        };

        /*
         * initialize serviceableAddress in ngStorage with key generated from buySession service
         */
        _self.serviceableAddress = $localStorage.$default(
          buySession.setCheckoutSessionObj(
            buySession.getKeyId('serviceableAddress', _self.samKey),
            sessionServiceableAddress
          )
        );

        /*
         * update serviceableAddress cached in ngStorage
         */
        _self.serviceableAddress[
          buySession.getCheckoutSessionKey(buySession.getKeyId('serviceableAddress', _self.samKey))
        ] = sessionServiceableAddress;

        var that = this;

        // if tier information is passed in; add to cart
        if (
          !angular.isUndefinedOrNull(data.service) &&
          !angular.isUndefinedOrNull(data.tier) &&
          !angular.isUndefinedOrNull(data.tier.selectedOffer)
        ) {
          if (data.service === 'iptv') {
            //cable service check
            samKeyService.iptv.offerExistsInOffersList(data.tier, _self.samKey).then(
              function(result) {
                if (result.data.offerExist === false) {
                  // offer doesn't exist in list of offers; prompt user
                  setState('offerNotAvailable');

                  // wipe out data.service and push through $scope.continue without offer details
                  data = {};
                } else {
                  // offer exists in new list of offers
                  $modalInstance.close();
                  $rootScope.userPref.samKey = _self.samKey;
                  $rootScope.userPref.auId = $scope.auId;
                  //
                  //// Todo: cartManager.iptv.addOffer() calling.
                  //if (data.targetState)
                  //  $state.go(data.targetState);
                  //
                  //that.continueProcessing = false;
                }
              },
              function() {
                that.continueProcessing = false;
                setState('serverError');
              }
            );
          } else if (data.service === 'internet' || data.service === 'btsPromotion') {
            // check if offer is still valid in the new internet offers based on samkey
            samKeyService.internet.offerExistsInOffersList(data.tier, _self.samKey, data.service).then(
              function(result) {
                if (result.data && result.data.error && result.data.error === '50003') {
                  $modal.open({
                    templateUrl: 'modules/core/views/invalid-offer-modal.html',
                    controller: [
                      '$scope',
                      '$modalInstance',
                      function($scope, $modalInstance) {
                        $scope.title = 'Technical Error';
                        $scope.message = "I'm sorry we encountered an issue while proccessing your request.";
                        $scope.okButtonLabel = 'What can I get?';

                        $scope.cancel = function() {
                          $modalInstance.close();
                        };
                        $scope.ok = function() {
                          $rootScope.userPref.samKey = _self.samKey;
                          $rootScope.userPref.auId = $scope.auId;
                          $modalInstance.close();
                        };
                      }
                    ]
                  });
                  $modalInstance.close();
                } else if (result.data.offerExist === false) {
                  // offer doesn't exist in list of offers; prompt user
                  setState('offerNotAvailable');

                  // wipe out data.service and push through $scope.continue without offer details
                  data = {};
                } else {
                  // offer exists in new list of offers

                  $rootScope.userPref.samKey = _self.samKey;
                  $rootScope.userPref.auId = $scope.auId;

                  cartManager.internet.addOffer(data.tier, data.tier.products[0].offers[0].offerId).then(
                    function() {
                      $modalInstance.close();
                      if (data.targetState) {
                        $state.go(data.targetState);
                      }
                    },
                    function(reason) {
                      console.log(reason);
                      if (reason === '60025') {
                        $modalInstance.close();
                      } else {
                        that.continueProcessing = false;
                        setState('serverError');
                      }
                    }
                  );
                }
                that.continueProcessing = false;
              },
              function(reason) {
                console.log('@naa offerIdExist ', reason);

                if (reason.data && reason.data.error && reason.data.error === '50003') {
                  $modal.open({
                    templateUrl: 'modules/core/views/invalid-offer-modal.html',
                    controller: [
                      '$scope',
                      '$modalInstance',
                      function($scope, $modalInstance) {
                        $scope.title = 'Technical Error';
                        $scope.message = "I'm sorry we encountered an issue while proccessing your request.";
                        $scope.okButtonLabel = 'What can I get?';

                        $scope.cancel = function() {
                          $modalInstance.close();
                        };
                        $scope.ok = function() {
                          $rootScope.userPref.samKey = _self.samKey;
                          $rootScope.userPref.auId = $scope.auId;
                          $modalInstance.close();
                        };
                      }
                    ]
                  });
                  $modalInstance.close();
                } else {
                  that.continueProcessing = false;
                  setState('serverError');
                }
              }
            );
          }
        } else {
          that.continueProcessing = false;
          $modalInstance.close();

          $rootScope.userPref.samKey = _self.samKey;
          $rootScope.userPref.auId = $scope.auId;
        }
      };

      $scope.multipleUnitSelectRule = {};

      $scope.setResponseMultiUnit = function(response) {
        // send the `response` to your server for verification.
        console.log('SETTT RESPONSEEEEEE multiunit', response);
        $scope.recaptcha.multiUnit.token = response;

        checkServiceability($scope.recaptcha.multiUnit.formName, $scope.recaptcha.multiUnit.token);
        $scope.selectedMultiAddress = null;

        console.log('check serviceability nowwwwwwwwwww');
      };

      /**
       * @description
       * Multiple address return from SS API
       */
      $scope.selectedMultiAddress = {};
      //TODO : check why form is not initialzed second time
      $scope.completedForm = function(formName) {
        console.log('>>>>>>>>>>>>>>>>>>> completed form');

        $scope.selectedMultiAddress.addressPrestine = false;
        if (!util.validateFormOnSubmit(formName)) {
          return false;
        }

        if ($scope.selectedMultiAddress.addressSelected === false || !$scope.selectedMultiAddress.addressSelected) {
          return false;
        }

        console.log('**** formname', formName);

        _self.queriedAddress = $scope.selectedMultiAddress;
        _self.queriedAddress.multipleUnits = true;
        _self.queriedAddress.cpDomesticId = $scope.selectedMultiAddress ? $scope.selectedMultiAddress.cpDomesticId : '';
        $scope.recaptcha.multiUnit.formName = formName;

        // $scope.toggleProcessing();

        if ($rootScope.ruiMethods.user.is.agent() || $rootScope.isByPassed) {
          checkServiceability(formName, null);
          $scope.selectedMultiAddress = null;
        } else {
          if ($scope.recaptcha.multiUnit.token) {
            console.log('RESETTTTTTTTTTTTTTTTT! multi unit!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
            vcRecaptchaService.reload($scope.recaptcha.multiUnit.widgetId);
          }

          console.log('executeeeee');
          vcRecaptchaService.execute($scope.recaptcha.multiUnit.widgetId);
        }
      };

      /* using same form in loop does not bind model
       * Use below to update
       */
      $scope.selectedMultiAddress = {};

      $scope.updateRadioModel = function(radioValue) {
        if (typeof radioValue === 'string') {
          radioValue = JSON.parse(radioValue);
        }
        $scope.selectedMultiAddress = radioValue;
        $scope.selectedMultiAddress.addressSelected = true;
        $scope.selectedMultiAddress.addressPrestine = false;
      };

      /**
       * @description
       */
      var checkServiceability = function(formName, token) {
        console.log('>AAAAAAAAAAAAAAAAAAAA check', formName);
        // set multiunit form to prestine
        if (formName) {
          formName.$setPristine();
        }

        if (_self.queriedAddress.province.toLowerCase() !== data.province) {
          var requiredService = null;
          $scope.noFootPrint = false;

          //Service Address selected outside current selected province
          console.log('---PROV MISMATCH---');

          // set new province in scope to pass around
          $scope.newProvince = _self.queriedAddress.province.toLowerCase();

          // check if there is a service dependency for this state
          if ($state.current.data && $state.current.data.service) {
            requiredService = $state.current.data.service;
            if (requiredService === 'btsPromotion') {
              requiredService = 'internet';
            }
          }

          // if the requested province doesn't have current footprint, prompt user
          if (requiredService && !$rootScope.ruiMethods.serviceAvailable(requiredService, $scope.newProvince)) {
            $scope.noFootPrint = true;

            // generate dynamic copy for no footprint province
            var promises = [
              $translate('global.label.nonServiceableProvince'),
              $translate('global.message.nonServiceableProvince'),
              $translate('global.label.' + requiredService),
              $translate('global.province.' + $scope.newProvince + '.name'),
              $translate('global.cta.nonServiceableProvince'),
              $translate('global.province.' + $scope.newProvince + '.abbr')
            ];

            // on success
            $q.all(promises).then(function(responses) {
              var replaceMessageChar = function() {
                if (responses[5].toUpperCase() === 'QC') {
                  return responses[1]
                    .replace('[service]', responses[2])
                    .replace('en', 'au')
                    .replace('[prov]', responses[3]);
                }
                return responses[1].replace('[service]', responses[2]).replace('[prov]', responses[3]);
              };

              var replaceOkButtonChar = function() {
                if (responses[5].toUpperCase() === 'BC') {
                  return responses[4].replace('[prov]', 'B.C.');
                } else if (responses[5].toUpperCase() === 'QC') {
                  return responses[4].replace('en', 'au').replace('[prov]', responses[5]);
                } else {
                  return responses[4].replace('[prov]', responses[5]);
                }
              };

              $scope.noFootPrintMessage = replaceMessageChar();
              $scope.noFootPrintButton = replaceOkButtonChar();
            });
          }

          // when address is in another province => set modal state to `otherProvince`
          setState('otherProvince');
        } else {
          $scope.checkingServiceability = true;
          serviceabilityService
            .checkServiceability(_self.queriedAddress, {
              'x-recaptcha-token': token
            })
            .success(function(data) {
              $scope.checkingServiceability = false;

              // CHECK SEQ:
              // CALL SERVER
              // CHECK IF ADDRESS IS IN SERVER
              // CHECK IF ADDRESS IS FRAUD
              // CHECK IF ADDRESS IS IN THE SAME PROVINCE
              // CHECK IF ADDRESS IS SERVICEABLE

              if (data.error) {
                console.log('---ADDRESS NOT FOUND IN SERVER---');
                _satellite.setVar('error', 'FHSI | addressServices failed');
                _satellite.track('bfa-fhsi-error');

                if (data.error === '10068') {
                  // handle PCR 31
                  setState('invalidAUID');
                } else {
                  // when serviceability-check returns --address-not-in-server, error: true => set modal state to `addressNotFound`
                  setState('addressNotFound');
                  _self.queriedAddress = {};
                  triggerDtmRule(dtmServiceConstants.dtmRules.availCheckNo.name);
                }
              } else {
                if (data.multipleUnits) {
                  // EC-6128 75 - Address Serviceable Error Message
                  //data.
                  $scope.selectedMultiAddress = {};

                  console.info(data.addressInfoList);
                  $scope.selectedMultiAddress.addressSelected = false;
                  $scope.selectedMultiAddress.addressPrestine = true;

                  setState('multipleUnits', { addressInfoList: data.addressInfoList });
                } else if (data.callCare === true) {
                  // when serviceability-check returns callCare:true => set modal state to `fraud`
                  setState('fraud');
                  _self.queriedAddress = {};
                } else {
                  console.log('---UNFRAUDULENT---', _self.queriedAddress);

                  if (_self.queriedAddress.province.toLowerCase() !== uteLocale.province) {
                    //Service Address selected outside current selected province
                    console.log('---PROV MISMATCH---');

                    // set new province in scope to pass around
                    $scope.newProvince = _self.queriedAddress.province.toLowerCase();

                    // when address is in another province => set modal state to `otherProvince`
                    setState('otherProvince');
                    _self.queriedAddress = {};
                  } else {
                    // NOTES:
                    // data.serviceAddressInd === false :: !serviceable
                    // data.serviceAddressInd === '' :: no services found
                    // data.serviceAddressInd === true :: serviceable > display services

                    // data.serviceAddressID !== '' :: serviceable
                    // data.serviceAddressID === '' :: !serviceable

                    if (data.serviceAddressInd === false) {
                      // if not serviceable address address
                      console.log('---ADDRESS IS NOT SERVICEABLE!!!');

                      // when serviceability-check returns serviceAddressInd: false => set modal state to `notServiceable`
                      setState('notServiceable');
                      _self.queriedAddress = {};
                      triggerDtmRule(dtmServiceConstants.dtmRules.availCheckNo.name);
                    } else if (data.serviceAddressID !== '' && data.serviceAddressInd) {
                      if (data.cableCondition == 'Unwired' && brt.isBRTUnwired() == true) {
                        //CH-4586 BEGIN
                        console.log('BRT unwired switch is ==>', brt.isBRTUnwired());
                        console.log('== Connection is unwired ===');
                        // address is serviceable yo!
                        console.log('---ADDRESS IS SERVICEABLE UNWIRED---');
                        ssServiceableAddressResponse = data;

                        // when serviceability-check returns serviceAddressID: "" => set modal state to `serviceable`
                        serviceabilityService.cleanPrevSelectedOffer();
                        setState('Unwired');
                        
                        // set samkey in scope to pass arround
                        _self.samKey = data.serviceAddressID;
                        $scope.auId = data.addressUniqueID;
                        triggerDtmRule(dtmServiceConstants.dtmRules.availCheckYes.name);
                        
                      } else {
                        
                        // address is serviceable yo!
                        console.log('---ADDRESS IS SERVICEABLE---');
                        ssServiceableAddressResponse = data;
                        serviceabilityService.cleanPrevSelectedOffer();
                        setState('serviceable');
                        
                        //console.log("all Data===>", data);
                        _self.samKey = data.serviceAddressID;
                        $scope.auId = data.addressUniqueID;
                        triggerDtmRule(dtmServiceConstants.dtmRules.availCheckYes.name);
                      } //CH-4586 END
                    } else {
                      setState('serverError');
                      _self.queriedAddress = {};
                    }
                  }
                }

                window.fnametemp = $scope.formName;
                //                $scope.formName.dropdownMultiaddress.$modelValue=null

                //$('#selectedMultiAddressDrp').val("null");
                console.log($scope.formName);
              }
              // vcRecaptchaService.reset($scope.recaptcha.widgetId);
            })
            .error(function(err) {
              // Technical difficulties on Serviceability detected
              console.log('error', err);

              // when failed to establish connection to server => set modal state to `serverError`
              setState('serverError');

              $scope.checkingServiceability = false;
              _self.queriedAddress = {};

              // vcRecaptchaService.reset($scope.recaptcha.widgetId);
            });
        }
      };

      $scope.onEnd = function() {
        /* remove first element drop down*/
        $timeout(function() {
          $('.selectMultipleAddress option:empty').remove();
        }, 1);
      };

      /**
       *
       */
      $scope.autocompleteOff = function() {
        document.getElementById('addressLookup').setAttribute('autocomplete', 'off');
      };

      /**
       *
       */
      $scope.lookupAddress = function() {
        console.log('lookuppppppp>>>>>', $scope.recaptcha);

        document.getElementById('addressLookup').setAttribute('autocomplete', 'off');

        $scope.emailVerify = false;
        $scope.emailAddress = '';

        if (_.isEmpty(_self.queriedAddress)) {
          $scope.serviceability.invalidAction = true;
          return;
        }

        if ($rootScope.ruiMethods.user.is.agent() || $rootScope.isByPassed) {
          if (cartManager.getQuantity() > 0) {
            cartManager.cleanCart().then(function() {
              checkServiceability(null, null);
            });
          } else {
            checkServiceability(null, null);
          }
        } else {
          // console.log("EXECUTING", $scope.recaptcha.initial.token)

          // $scope.toggleProcessing();
          // $scope.checkingServiceability = true;

          if ($scope.recaptcha.initial && $scope.recaptcha.initial.token) {
            console.log('RESETTTTTTTTTTTTTTTTT!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
            vcRecaptchaService.reload($scope.recaptcha.initial.widgetId);
          }

          vcRecaptchaService.execute($scope.recaptcha.initial.widgetId);
        }
      };

      /**
       *
       */
      $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
        serviceabilityService.clearPca();
      };

      /**
       *
       */
      $scope.cancelProvinceChange = function() {
        $modalInstance.dismiss('cancel');
      };

      /**
       *
       * @param province
       */
      $scope.changeProvince = function(province) {
        provinceService.update(province);
        // $modalInstance.close();
      };

      /**
       *
       */
      $scope.checkAnotherAddress = function() {
        console.log('@checkAnotherAddress()');

        _self.queriedAddress = {};
        $scope.address = null;
        $scope.serviceable.address = '';
        setState('default');
      };

      /**
       *
       */
      $scope.showSignIn = function() {
        $modalInstance.dismiss('cancel');
        if (($window.location.href || '').indexOf('#/signin') === -1) {
          $window.setCookie('deepJSON', window.location.href, { path: '/', domain: '.fido.ca' });
        }
        janrainService.renderLogin(undefined, 'CHECK_AVAILABILITY_MODAL');
      };

      /**
       *
       * @param e
       */
      $scope.canadaPostNotError = function(e) {
        console.log('canadapost not available. this is called', e);
        $scope.flagCanadaPostNotAvailable = true;
        $scope.$apply();
      };

      /**
       *
       */
      $scope.canadaPostNotFound = function() {
        console.log('canadapost address not found is called');

        // remove canada post drop down when canada post address-not-found
        $scope.addressNotFound = true;
        // console.log($('.pca .pcaautocomplete.pcatext'));

        // remove pca dropdown out of the way
        // angular.element($('.pca .pcaautocomplete.pcatext'))[0].children[2].style.display = 'none';

        serviceabilityService.clearPca();

        $scope.address = null;
        $scope.$apply();
      };

      triggerDtmRule(dtmServiceConstants.dtmRules.availCheckOpen.name);

      function triggerDtmRule(ruleName) {
        if (data.service === 'internet' || data.service === 'btsPromotion') {
          try {
            $timeout(function() {
              dtmService.direct(ruleName);
            }, 10);
          } catch (e) {
            console.log(e.message);
          }
        }
      }
    }
  ]);
})();
